import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../index'

const { env } = window

const useUpdateTenantBrandingMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const updateTenantBranding = async (data) => {
    const url = encodeURI(`${env.apiUrl}/tenants/${data.id}`)
    const formData = new FormData()
    data.deleteLoginImage !== undefined &&
      formData.append('deleteLoginImage', data.deleteLoginImage)
    data.deleteLogoImage !== undefined &&
      formData.append('deleteLogoImage', data.deleteLogoImage)
    data.loginImageContent !== undefined &&
      formData.append('loginImageContent', data.loginImageContent)
    data.logoImageContent !== undefined &&
      formData.append('logoImageContent', data.logoImageContent)
    data.loginAltText !== undefined &&
      formData.append('loginAltText', data.loginAltText)
    data.logoAltText !== undefined &&
      formData.append('logoAltText', data.logoAltText)
    data.primaryColor !== undefined &&
      formData.append('primaryColor', data.primaryColor)
    data.secondaryColor !== undefined &&
      formData.append('secondaryColor', data.secondaryColor)
    const response = await securedFetch(url, {
      method: 'PATCH',
      body: formData
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ data }) => updateTenantBranding(data),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error updating project settings'),
    onSuccess: () => {
      setMessage('Your project settings have been updated successfully.')
      queryClient.invalidateQueries({ queryKey: ['assets'] })
      queryClient.invalidateQueries({ queryKey: ['tenants'] })
    },
    onSettled: progressEnd
  })
}

export { useUpdateTenantBrandingMutation }
